import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { RenterForm } from '@core/components/abstract/renter-form';

@Component({
  selector: 'renter-rent-banned',
  templateUrl: './renter-rent-banned.component.html',
  styleUrls: ['./renter-rent-banned.component.scss']
})
export class RenterRentBannedComponent extends RenterForm implements OnInit {

  constructor(
    private renterFormService: RenterRegFormService
  ) {
    super();
  }

  get form(): FormGroup {
    try {
      return this.renterFormService.renterForm as FormGroup;
    } catch (e) {
      throw new Error('Renter form was not built');
    }
  }

  ngOnInit() {
  }

}
